// extracted by mini-css-extract-plugin
module.exports = {"top-section":"Top_top-section__1DCUH","title":"Top_title__3gfZQ","text":"Top_text__2wmXz","subtitle":"Top_subtitle__1BV88"};